import { FC, useMemo, useState } from 'react'
import classNames from 'classnames'
import SvgBackward5 from '../../components/icons/Backward5'
import SvgForward10 from '../../components/icons/Forward10'
import { RewindDirection } from '../enums/RewindDirection'
import { useChannelsRewindHotKeys } from './hooks/useChannelsRewindHotKeys'
import './ChannelsRewind.scss'

export const ChannelsRewind: FC = () => {
  const [direction, setDirection] = useState<{ value: RewindDirection } | null>(null)
  const key = useMemo(() => direction && Date.now(), [direction])

  useChannelsRewindHotKeys((value) => setDirection({ value }))

  return direction ? (
    <div
      className={classNames('ChannelsRewind', {
        '-forward': direction.value === RewindDirection.Forward,
        '-backward': direction.value === RewindDirection.Backward,
      })}
      onAnimationEnd={() => {
        setDirection(null)
      }}
      key={key} // to restart css animation
    >
      {direction.value === RewindDirection.Backward ? <SvgBackward5 /> : <SvgForward10 />}
    </div>
  ) : null
}
